import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AbstractDialogComponent, ContentField } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-catalougue-pop-up-dialog',
  templateUrl: './product-catalougue-pop-up-dialog.component.html',
  styleUrls: ['./product-catalougue-pop-up-dialog.component.scss'],
})
export class ProductCataloguePopUpDialogComponent extends AbstractDialogComponent implements OnInit {
  dialogContent: SafeHtml | null = null;

  constructor(public activeModal: NgbActiveModal, private domSanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    const contentField = this.inputs?.[0] as ContentField;
    this.dialogContent = this.domSanitizer.bypassSecurityTrustHtml(contentField.value.value);
  }

  onClose(): void {
    this.activeModal.close();
  }
}
